<script>
import Vue from 'vue'
import API from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

const mapFieldName = (item) => ({
  id: item['id'],
  description: item['description'],
  fullDescription: item['full_description'],
  pvCode: item['pv_code'],
})

export default {
  name: 'TitleNameSelect',
  props: {
    disabled: Boolean,
  },
  model: { event: 'change' },
  data() {
    return { titles: [] }
  },
  methods: {
    fetchDimTitle: async function () {
      const headers = generateAuthorizationRequestHeader()
      const url = API.GENERAL.NAME_PREFIX
      const response = await Vue.http.get(url, { headers })
      return response.json()
    },
    getDimTitle: async function () {
      const {
        result: { title },
      } = await this.fetchDimTitle()
      return title.map((item) => mapFieldName(item))
    },
    emitPvCode: function (event) {
      this.$emit('change', event.target.value)
    },
  },
  async mounted() {
    const titles = await this.getDimTitle()
    const [misses] = titles
    this.titles = titles
    this.$emit('change', misses['description'])
  },
}
</script>

<template>
  <select class="form-control input-sm" :disabled="disabled" @change="emitPvCode">
    <option v-for="title in titles" :key="title.id" :value="title.description">
      {{ title.description }}
    </option>
  </select>
</template>
